import { useEffect } from 'react';

export const ScrollbarCustomization = () => {
  useEffect(() => {
    const element = document.getElementsByTagName('body')[0];
    element.classList.add('custom-scroll');
  }, []);
  return null;
};
